export default {
  onAbort: () => { },
  onCanPlay: () => { },
  onCanPlayThrough: () => { },
  onDurationChange: () => { },
  onEmptied: () => { },
  onEnded: () => { },
  onError: () => { },
  onLoadedData: () => { },
  onLoadedMetadata: () => { },
  onLoadStart: () => { },
  onPause: () => { },
  onPlay: () => { },
  onPlaying: () => { },
  onProgress: () => { },
  onRateChange: () => { },
  onSeeked: () => { },
  onSeeking: () => { },
  onStalled: () => { },
  onSuspend: () => { },
  onTimeUpdate: () => { },
  onVolumeChange: () => { },
  onWaiting: () => { },
}